import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { sourceCodeList } from "../config/constant";
export default function NavBar(props) {
    let location = useLocation();

    const [filteredData, setFilteredData] = useState([]);
    const [wordEntered, setWordEntered] = useState("");

    const handleFilter = (event) => {
        const searchWord = event.target.value;
        setWordEntered(searchWord);
        const listD = []
        sourceCodeList.forEach((elements, index) => {
            if (elements.type) {
                elements.subs.forEach((element, indexs) => {
                    listD.push(element)
                })
            } else {
                listD.push(elements)
            }
        })
        const newFilter = listD.filter((value) => {
            return value.component_name
                .toLowerCase()
                .includes(searchWord.toLowerCase());
        });
        if (searchWord === "") {
            setFilteredData([]);
        } else {
            setFilteredData(newFilter);
        }
    };

    const clearInput = () => {
        setFilteredData([]);
        setWordEntered("");
    };

    return (
        <div className="row sticky-top">
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                {/* <!-- ======= Mobile nav toggle button ======= --> */}
                <button
                    //className="btn mobile-nav-toggle d-xl-none mx-1"
                    className="btn mx-3"
                    style={{
                        backgroundColor: "dark",
                        color: "white",
                        fontSize: "22px",
                    }}
                    onClick={
                        props.showSidebar
                    }
                >
                    <i className="fa fa-bars "></i>
                </button>
                <div className="container">
                    <div>
                        <Link className="h3 fw-bold font-monospace text-decoration-none " style={{
                            color: "white",
                        }} to="/">
                            Android Addict
                        </Link>
                    </div>
                    <form className="d-flex" style={{
                        float: "right"
                    }}>

                        <div className="container" >
                            <input
                                className="form-control me-2"
                                type="search"
                                placeholder="Search"
                                aria-label="Search"
                                value={wordEntered}
                                onChange={handleFilter}
                            />
                            {filteredData.length > 0 && (
                                <div
                                    className="searchInputs"
                                    style={{
                                        position: "absolute",
                                        backgroundColor: "black",
                                        width: "220px",
                                        // height: "200px",
                                        // overflowY: "scroll",
                                    }}
                                >
                                    {filteredData.map((value, key) => {
                                        return (
                                            <Link
                                                to={value.path}
                                                className={`nav-link ${location.pathname === value.path
                                                    ? "bg-dark"
                                                    : "text-white"
                                                    }`}
                                                onClick={clearInput}
                                            >
                                                {value.component_name}
                                            </Link>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </nav>
        </div>
    );
}
